import ContentSticky from "./components/ContentSticky";

const Plugin = {
  instances: [],
  install(app) {
    app.component("content-sticky", ContentSticky);

    const registerStickPanel = (instance) => {
      if (notDefined(instance)) {
        throw `Invalid ContentSticky instance: ${instance}`;
      }
      this.instances.push(instance);
    };

    const unregisterStickPanel = () => {
      this.instances.pop();
    };

    const setContentStickyComponent = (component, params) => {
      const instancesLength = this.instances.length;
      if (instancesLength === 0) {
        throw `stickpanel instance is not registered.`;
      }
      this.instances[instancesLength - 1].set(component, params);
    };
    const removeContentStickyComponent = () => {
      const instancesLength = this.instances.length;
      if (instancesLength === 0) {
        return;
      }
      this.instances[instancesLength - 1].remove();
    };
    const checkHasActiveComponent = () => {
      return this.instances[this.instances.length - 1].components.length;
    };

    app.config.globalProperties.$stickpanel = {
      register(instance) {
        registerStickPanel(instance);
      },
      unregister() {
        unregisterStickPanel();
      },
      set(component, params) {
        setContentStickyComponent(component, params);
      },
      remove() {
        removeContentStickyComponent();
      },
      hasActiveComponent() {
        return checkHasActiveComponent();
      },
    };
    this.$stickpanel = app.config.globalProperties.$stickpanel;
  },
};
export default Plugin;
